import styled from 'styled-components';

export const LargeDeliveryBannerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 20px;
  padding: 14px 16px;
  border-radius: 8px;

  &.warning {
    background: #fff4e5;
    border: 1px solid #ffd8a8;
  }

  &.success {
    background: #edf7ed;
    border: 1px solid #c8e6c9;
    align-items: flex-start;
  }

  button {
    flex: 0 0 auto;
  }
`;

export const LargeDeliveryBannerContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  flex: 1 1 auto;
`;

export const LargeDeliveryBannerIcon = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  margin-top: 1px;

  svg {
    font-size: 20px;
  }

  &.warning svg {
    color: #f5a623;
  }

  &.success svg {
    color: #2e7d32;
  }
`;

export const LargeDeliveryBannerTitle = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;

  .warning & {
    color: #8a5a12;
  }

  .success & {
    color: #1b5e20;
  }
`;

export const LargeDeliveryBannerSubtitle = styled.p`
  margin: 4px 0 0;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: #5b8a5f;
`;
